// The composer's attachment rules (spec 17 §4.1, D-329), mirrored from the
// send door so the manager sees a refusal before pressing Send; the server
// re-checks every one of them. One message's files leave in one send, so they
// are capped together as well as each, at most ten of them, and the text that
// rides them is the messenger's caption, at most 1024 characters. Pure.

/** §2.8: one file. */
export const MEDIA_MAX_BYTES = 25 * 1024 * 1024;
/** D-329: one message's files together. */
export const MEDIA_MESSAGE_MAX_BYTES = 50 * 1024 * 1024;
/** The contract's limit on `media_s3_keys`, and the messenger's album size. */
export const MEDIA_MAX_FILES = 10;
/** The messenger's caption cap. */
export const CAPTION_MAX = 1024;

/** Why a file cannot join a message that already holds `attached` sizes, or
 * null when it can. */
export function attachRefusal(
  attached: readonly number[],
  fileSize: number,
): "file" | "total" | "count" | null {
  if (attached.length >= MEDIA_MAX_FILES) return "count";
  if (fileSize > MEDIA_MAX_BYTES) return "file";
  const total = attached.reduce((sum, size) => sum + size, 0);
  return total + fileSize > MEDIA_MESSAGE_MAX_BYTES ? "total" : null;
}

/** The text's length when it is too long to ride `attachments` files, else
 * null. The messenger counts the text as typed, less the spaces at its ends,
 * in UTF-16 units, which is what a JavaScript string's length is. */
export function captionOverflow(text: string, attachments: number): number | null {
  if (attachments === 0) return null;
  const length = text.trim().length;
  return length > CAPTION_MAX ? length : null;
}
